export const useAverageBlockTime = () => {
  return 3;
};
